module.exports = __webpack_public_path__ + "img/homebg_3.aa218e5a.png";